<template>
    <slot name="trigger" :click="open"></slot>
    <modal v-model="modal" allow-close>
        <template v-slot:header>Create Social Media Post</template>
        <div class="form-group">
            <label>Title</label>
            <input type="text" name="social-title" :class="{'is-invalid':!validation.title}" class="form-control" v-model="title" required maxlength="225">
            <small v-if="!validation.title" class="invalid-feedback">A title is required</small>
        </div>
        <div class="form-group">
            <label>Description</label>
            <textarea :class="{'is-invalid':!validation.description}" class="form-control" v-model="description" required rows="5"></textarea>
            <small v-if="!validation.description" class="invalid-feedback">A description is required</small>
        </div>
        <div class="form-group">
            <label>Publish On</label>
            <datepicker :class="{'is-invalid':!validation.published_on}" class="form-control" :lower-limit="dateRange" placeholder="Select Publish Date" v-model="published_on"></datepicker>
        </div>
        <div class="form-group">
            <label>Image Upload</label> <small><i>Max Size 5MB</i></small><br/>
            <input type="file" ref="imageFile" class="form-control" @change="onAttachment" accept="image/jpeg, image/png">
        </div>
        <template v-slot:footer>
            <div class="d-flex justify-content-end">
                <button @click="modal = !modal" class="btn btn-default mx-2">Cancel</button>
                <button @click="save" class="btn btn-primary">Save</button>
            </div>
        </template>
    </modal>
</template>

<script lang="ts">
    import {defineComponent, reactive, ref} from "vue";
    import Datepicker from 'vue3-datepicker';
    import Modal from "@/components/modal.vue";
    import moment from 'moment';
    import {ISocial} from '@/interfaces/social-media-post';
    import {store} from "@/store";
    import {MutationTypes} from "@/store/modules/ux/mutations";
    import {NotificationIcon,NotificationColor} from "@/interfaces/notification";
    import {SocialMediaPost} from "@/models/social-media-post";

    export default defineComponent({
        name: "CreateSocialPost",
        components: {
            Datepicker,
            Modal
        },
        props:{
            //No Props
        },
        emits:['update'],
        computed:{
            dateRange(){
                let today = new Date();
                let priorDate = new Date(new Date().setDate(today.getDate() - 30));
                return priorDate;
            }
        },
        setup(props, {emit}){
            let file = ref<File>();
            const modal = ref(false);
            const open = ()=>modal.value = !modal.value;
            const title = ref('');
            const description = ref('');
            const imageFile = ref(null);
            const published_on = ref(null);
            const validation = reactive({
                'title':true,
                'description':true,
                'published_on':true,
            })
            const onAttachment = async(event:any) => {
                file.value = event.target.files[0];
            }
            const resetForm = ()=>{
                title.value = '';
                description.value = '';
                published_on.value = null;
            }
            const resetValidation = ()=>{
                validation.title = true;
                validation.description = true;
                validation.published_on = true;
            }

            const save = () =>{
                //reset validation
                resetValidation();

                //check validation
                if(title.value == '') validation.title = false;
                if(description.value == '') validation.description = false;
                if(published_on.value == null) validation.published_on = false;

                if(validation.title && validation.description && validation.published_on){
                    //save
                    let formData = new FormData();
                    formData.append("title", title.value);
                    formData.append("description", description.value);
                    formData.append("published_on", moment(published_on.value).format('YYYY-MM-DD'));
                    formData.append("file", file.value!);

                    SocialMediaPost.saveSocialMediaPost(formData).then((res)=>{
                        let post:ISocial = res.data;
                        emit('update',post);
                        modal.value = false;
                        resetForm();
                        store.commit(MutationTypes.addSystemNotification,{title:'Success',content:'Social Media Post has been created.',icon:NotificationIcon.SUCCESS,color:NotificationColor.GREEN});
                    });
                }
            }

            return{
                description,
                imageFile,
                modal,
                moment,
                onAttachment,
                open,
                published_on,
                save,
                SocialMediaPost,
                title,
                validation,
            }
        }
    });
</script>

<style scoped>

</style>
